import styles from './styles.module.scss';

export type SpinnerProps = {
  /** Changes the size of the spinner */
  size?: 'xsmall' | 'small' | 'medium';
  /** Changes the spinner variant */
  variant?: 'primary' | 'light';
  testId: string;
};

const COLORS: Record<string, string> = {
  primary: 'rgba(58, 126, 246, 1)',
  light: 'rgba(255, 255, 255, 1)',
};

export const Spinner = ({ size = 'small', variant = 'primary', testId }: SpinnerProps) => {
  switch (size) {
    case 'xsmall':
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          data-testid={`${testId}-spinner`}
        >
          <g id="16x16/Loading/Black and White">
            <g id="Group 28" className={styles.spinner}>
              <rect
                id="Rectangle 19"
                x="7.14282"
                y="2"
                width="1.71429"
                height="3.42857"
                rx="0.857143"
                fill={COLORS[variant]}
              />
              <rect
                id="Rectangle 18 Copy"
                x="7.14282"
                y="10.5714"
                width="1.71429"
                height="3.42857"
                rx="0.857143"
                fill={COLORS[variant]}
              />
              <rect
                id="Rectangle 20"
                x="3.15125"
                y="4.3634"
                width="1.71429"
                height="3.42857"
                rx="0.857143"
                transform="rotate(-45 3.15125 4.3634)"
                fill={COLORS[variant]}
              />
              <rect
                id="Rectangle 18 Copy_2"
                x="9.21216"
                y="10.4243"
                width="1.71429"
                height="3.42857"
                rx="0.857143"
                transform="rotate(-45 9.21216 10.4243)"
                fill={COLORS[variant]}
              />
              <rect
                id="Rectangle 21"
                x="11.6365"
                y="3.15125"
                width="1.71429"
                height="3.42857"
                rx="0.857143"
                transform="rotate(45 11.6365 3.15125)"
                fill={COLORS[variant]}
              />
              <rect
                id="Rectangle 18 Copy_3"
                x="5.57568"
                y="9.21216"
                width="1.71429"
                height="3.42857"
                rx="0.857143"
                transform="rotate(45 5.57568 9.21216)"
                fill={COLORS[variant]}
              />
              <rect
                id="Rectangle 18"
                x="14"
                y="7.14288"
                width="1.71429"
                height="3.42857"
                rx="0.857143"
                transform="rotate(90 14 7.14288)"
                fill={COLORS[variant]}
              />
              <rect
                id="Rectangle 18 Copy_4"
                x="5.42859"
                y="7.14288"
                width="1.71429"
                height="3.42857"
                rx="0.857143"
                transform="rotate(90 5.42859 7.14288)"
                fill={COLORS[variant]}
              />
            </g>
          </g>
        </svg>
      );
    case 'small':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          data-testid={`${testId}-spinner`}
        >
          <g opacity="0.9" id="24x24/Loading/Black and White">
            <g id="Group 28" className={styles.spinner}>
              <rect
                opacity="0.8"
                x="3.91876"
                y="5.93903"
                width="2.85714"
                height="5.71429"
                rx="1.42857"
                transform="rotate(-45 3.91876 5.93903)"
                fill={COLORS[variant]}
              />
              <rect
                opacity="0.5"
                x="14.0203"
                y="16.0405"
                width="2.85714"
                height="5.71429"
                rx="1.42857"
                transform="rotate(-45 14.0203 16.0405)"
                fill={COLORS[variant]}
              />
              <rect
                opacity="0.2"
                x="18.0609"
                y="3.91876"
                width="2.85714"
                height="5.71429"
                rx="1.42857"
                transform="rotate(45 18.0609 3.91876)"
                fill={COLORS[variant]}
              />
              <rect
                opacity="0.7"
                x="7.95941"
                y="14.0203"
                width="2.85714"
                height="5.71429"
                rx="1.42857"
                transform="rotate(45 7.95941 14.0203)"
                fill={COLORS[variant]}
              />
              <rect
                opacity="0.9"
                x="10.5714"
                y="2"
                width="2.85714"
                height="5.71429"
                rx="1.42857"
                fill={COLORS[variant]}
              />
              <rect
                opacity="0.6"
                x="10.5714"
                y="16"
                width="2.85714"
                height="6"
                rx="1.42857"
                fill={COLORS[variant]}
              />
              <rect
                opacity="0.4"
                x="16"
                y="13.4286"
                width="2.85714"
                height="6"
                rx="1.42857"
                transform="rotate(-90 16 13.4286)"
                fill={COLORS[variant]}
              />
              <rect
                opacity="0.7"
                x="2"
                y="13.4286"
                width="2.85714"
                height="6"
                rx="1.42857"
                transform="rotate(-90 2 13.4286)"
                fill={COLORS[variant]}
              />
            </g>
          </g>
        </svg>
      );
    //medium (case as default to avoid TS warnings)
    default:
      return (
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          data-testid={`${testId}-spinner`}
        >
          <g id="32x32/Loading/Black and White">
            <g id="Group 28" className={styles.spinner}>
              <rect opacity="0.9" x="14" y="2" width="4" height="8" rx="2" fill={COLORS[variant]} />
              <rect
                opacity="0.5"
                x="14"
                y="22"
                width="4"
                height="8"
                rx="2"
                fill={COLORS[variant]}
              />
              <rect
                opacity="0.8"
                x="4.68628"
                y="7.51471"
                width="4"
                height="8"
                rx="2"
                transform="rotate(-45 4.68628 7.51471)"
                fill={COLORS[variant]}
              />
              <rect
                opacity="0.4"
                x="18.8284"
                y="21.6569"
                width="4"
                height="8"
                rx="2"
                transform="rotate(-45 18.8284 21.6569)"
                fill={COLORS[variant]}
              />
              <rect
                opacity="0.2"
                x="24.4853"
                y="4.68628"
                width="4"
                height="8"
                rx="2"
                transform="rotate(45 24.4853 4.68628)"
                fill={COLORS[variant]}
              />
              <rect
                opacity="0.6"
                x="10.3431"
                y="18.8284"
                width="4"
                height="8"
                rx="2"
                transform="rotate(45 10.3431 18.8284)"
                fill={COLORS[variant]}
              />
              <rect
                opacity="0.3"
                x="30"
                y="14"
                width="4"
                height="8"
                rx="2"
                transform="rotate(90 30 14)"
                fill={COLORS[variant]}
              />
              <rect
                opacity="0.7"
                x="10"
                y="14"
                width="4"
                height="8"
                rx="2"
                transform="rotate(90 10 14)"
                fill={COLORS[variant]}
              />
            </g>
          </g>
        </svg>
      );
  }
};
